const tw = {
  loginMessage: {
    succeeded: '登入成功',
    failed: '已登出'
  },
  header: {
    login: '登入',
    debut: 'Debut 求職平台',
    manipulator: '企業徵才後台',
    bhuntr: '獎金獵人',
    findJob: '找工作',
    findCompany: '找公司',
    vacancies: '職缺',
    resumes: '履歷',
    companyImformation: '公司資訊',
    accountSettings: '帳號設定',
    doLogout: '登出',
    recruitHistory: '應徵記錄',
    savedVacancies: '收藏的工作',
    manageResumes: '管理我的履歷',
    userSettings: '個人檔案編輯',
    logout: '登出',
    signup: '註冊',
    competition: {
      aside: '選單'
    }
  },
  contactUs: {
    name: '姓名',
    email: 'Email',
    phone: '電話',
    content: '聯絡內容',
    submit: '儲存'
  },
  common: {
    modifyImage: '編輯圖片',
    cancel: '取消',
    save: '儲存',
    uploadFailed: '上傳檔案失敗了',
    fileSizeTooLarge: '上傳檔案大小太大了 (檔案限制 2MB 以下)',
    fileTypeIsNotAllow: '不允許上傳該種檔案格式',
    fileIsNotImage: '上傳檔案非圖片檔案',
    resetFilter: '重置',
    submit: '送出',
    underConstruction: '本功能將在近日內開放，敬請期待！',
    backPreviousPage: '回上一頁',
    notFoundSlogan: '喔歐～你好像迷路了！',
    backHomepage: '回到首頁',
    accountActived: '你的帳號開通成功了！',
    accountActiveFailed: '你的帳號開通失敗了！',
    pleaseClick: '請按',
    here: '這裡',
    toCompletedProfile: '繼續完成你的個人資料。',
    dearUser: '親愛的豬崽 :',
    yourAccountActivedFaileOrAlreadyActived: '・您的帳號可能已經開通，或開通失敗。請登入會員',
    checkAccountSettings: '檢視帳號狀態',
    ifAnyComments: '・如果您有任何疑問，請來函至',
    services: '客服中心',
    orContact: '或來電至',
    weWillService: '，客服專員將竭誠為您服務。',
    lastModified: '最後更新',
    folder: '資料夾',
    allVacancies: '全部工作',
    addFolder: '新增資料夾',
    areYouSure: '確認要做此操作？',
    removeTheUserFolder: '移除資料夾',
    yes: '好',
    removeTheUserFolderFailed: '移除資料夾失敗了',
    folderNameIsEmpty: '資料夾名稱不能為空白',
    updateTheUserFolderFailed: '更新資料夾失敗了',
    delete: '刪除',
    confirm: '確認',
    folderNotSelected: '請選擇資料夾',
    vacanciesNotSelected: '請選擇職缺',
    moveToFolderFailed: '移動履歷失敗了，請稍後再試一次。',
    addPhoto: '新增照片',
    selectFile: '選擇檔案',
    gender: '性別',
    birthday: '出生日期',
    onlyDisplayAge: '隱藏出生日期，僅顯示年齡',
    identifyNo: '身分證字號',
    pleaseFillYourIdentifyNo: '請輸入你的身份證字號',
    pleaseFillYourEmail: '請輸入您的 E-mail',
    accountNotActived: '帳號尚未啟用',
    chooseYourResume: '請選擇一個履歷',
    addResume: '新增履歷',
    succeeded: '成功',
    failed: '錯誤了！',
    add: '新增',
    all: '全部',
    filterByStatus: '依照狀態篩選',
    emailError: 'E-mail 格式錯誤',
    passwordError: '密碼錯誤',
    newPasswordError: '新密碼格式錯誤了。',
    oldPasswordError: '舊密碼錯誤了。',
    repeatPasswordError: '重複輸入的密碼錯誤了。',
    passwordRules: '密碼需要超過 8 碼，包含一個英文字和數字。',
    linkTitle: '名稱',
    fillSomething: '輸入後請按 Enter...',
    suggestTags: '建議: ',
    modifyResume: '編輯履歷',
    published: '開放中',
    unpublished: '關閉中',
    removeAttachment: '刪除附件檔案',
    registerSucceeded: '恭喜你註冊成功！',
    pleaseActiveYourAccount: '請檢查你的 E-mail 並啟動你的帳號，或是 ',
    resetPasswordFailed: '重設密碼請求失敗了',
    resetPasswordFailedMessage: '可能是密碼連結失效或是超過時間限制，請重新操作。',
    manipulatorVerified: '您的企業帳號需要審核通過後，才能發佈徵才訊息。我們會盡快審核，並以 E-mail 通知您審核結果。',
    removeFile: '移除檔案',
    previewResume: '預覽履歷',
    close: '關閉',
    sweetAlert: '溫馨小提醒',
    continueEdit: '好，繼續填寫',
    cancelEdit: '沒關係，請繼續',
    loading: '資料讀取中，請稍後...',
    or: '或',
    dragAndDrop: '將檔案放到這裡',
    filterButton: '篩選'
  },
  company: {
    logoFileNotExists: '請上傳一個 Logo 圖檔',
    bannerFileNotExists: '請上傳 Banner 圖檔',
    sortFilter: {
      company: '公司大的在前',
      career: '職缺多的在前',
      published: '最後更新時間'
    }
  },
  resume: {
    onboard: {
      anyTime: '隨時'
    },
    removeSavedVacancies: '刪除所選的收藏的工作',
    entry: {
      birthday: '出生日期：',
      cellphone: '手機：',
      address: '通訊地址：',
      age: '{age} 歲',
      name: '履歷名稱',
      modifyInFullPage: '進入整頁編輯模式',
      educational: '教育背景',
      modify: '編輯',
      attachments: '附件',
      workExperiences: '工作經驗',
      introduction: '自我介紹',
      modifyTitle: '編輯資訊',
      content: '求職資料',
      onBoard: '最快可上班日',
      status: '就業狀態',
      jobTitle: '期望職稱',
      salary: '期望待遇',
      contactPeriod: '可聯繫時間',
      anyTime: '隨時',
      skills: '工作技能',
      proSkills: '專業技能',
      languages: '語言技能',
      licenses: '證照與成就',
      links: '相關連結'
    },
    removeRecruited: '移除應徵記錄',
    removeRecruitedFailed: '刪除應徵記錄失敗了',
    resumenameCannotBeEmpty: '履歷名稱不可為空值。',
    missingRelatedLinkData: '新增相關連結未填寫完整，你要繼續填寫嗎？',
    missingJobHistoryData: '新增工作經歷未填寫完整，你要繼續填寫嗎？',
    missingStudyHistoryData: '新增學歷未填寫完整，你要繼續填寫嗎？',
    continueDoesNotSave: '若要繼續，則不會儲存你的資料。'
  },
  loginModal: {
    accountPlaceholder: '請輸入您註冊時的 Email',
    passwordPlaceholder: '密碼',
    loginFailed: '帳號或密碼錯誤，請再試一次。<a href="/signup?login_type=forgotpassword">忘記密碼了嗎？</a>',
    registerFailed: '註冊失敗了',
    accountAlreadyExists: '您的 E-mail 帳號已註冊過了！',
    areYouForgotPassword: '豬崽忘記密碼了嗎？',
    slogan: '初出茅廬的完美登場',
    youCanSignupWith: '你可以由此登入',
    or: '或',
    account: '帳號',
    password: '密碼',
    login: '登入',
    username: '名稱',
    yourPassword: '密碼',
    repeatYourPassword: '再輸入一次你的密碼',
    goSignup: '註冊',
    forgotPasswordMessage: '輸入註冊時的 Email，我們會寄信跟你說解密法',
    goLogin: '已經有帳號，直接登入',
    forgotPassword: '忘記密碼',
    forgotPasswordFailed: '忘記密碼查詢失敗了，請稍後再試一次',
    forgotPasswordButton: '忘記密碼',
    forgotPasswordAccount: '帳號',
    facebookLogin: 'Facebook 登入',
    twitterLogin: 'Twitter 登入',
    googleLogin: 'Google+ 登入'
  },
  resetPassword: {
    fillAccount: '請輸入 E-mail 帳戶',
    fillEmail: '請填寫 E-mail',
    fillPassword: '請輸入密碼',
    repaetPasswordNotTheSame: '重複輸入的密碼不相同',
    accountError: '帳號錯誤',
    forgotPasswordSucceeded: '成功',
    title: '重設密碼',
    account: '帳號',
    newPassword: '新的密碼',
    confirmPassword: '請再輸入一次新的密碼',
    ok: '好',
    oops: '喔歐',
    errorMessage: '重設密碼失敗了，請稍後再試一次',
    succeeded: '成功',
    succeededMessage: '重設密碼成功！',
    loginPage: '登入',
    passwordNotTheSame: '重複輸入的密碼不相同',
    cannotFindUserByEmail: '這個 E-mail 找不到使用者，請確認 E-mail 是否正確'
  },
  intern: {
    categoryChoise: '產業',
    search: {
      tagSearch: '標籤搜尋',
      tips: '搜尋（公司、職務、地區... 等等）'
    },
    scaleRange: '公司規模',
    stageChoise: '公司階段',
    entry: {
      similar: '相關的職缺'
    },
    card: {
      location: '地點: {city} {dist}',
      salary: '薪資: {type} {amount} 元',
      publishedAt: '更新時間: {publishedAt}',
      empty: '找不到相關的工作，請更改條件重新搜尋一次吧！',
      emptyCompanies: '找不到相關的公司，請更改條件重新搜尋一次吧！'
    },
    natureChoise: '工作類型',
    locationChoise: '上班地點',
    typeChoise: '工作內容',
    salaryRange: '報酬',
    worklevel: '工作經驗要求',
    scaleRanges: {
      underFour: '4 人以下',
      aboveFive: '5-9 人',
      aboveTen: '10-29 人',
      aboveThirty: '30-49 人',
      aboveFifty: '50-99 人',
      aboveOneHundred: '100-249 人',
      aboveThreeHundred: '500 人',
      aboveFiveHundred: '500 人以上'
    },
    stage: {
      bootstraping: 'Bootstraping',
      angel: '天使種子輪 (Angel/Seed Round)',
      around: 'A 輪 (A Round)',
      bcround: 'B 輪以上 (B or C Round)',
      enterprise: '成熟企業 (Enterprise)',
      ipo: '已上市 (IPO)'
    },
    sort: {
      new: '更新時間',
      salary: '薪資高的在前'
    }
  },
  entry: {
    nonTypes: '不限',
    nonWorkLevels: '不限',
    nonOnboard: '不限',
    nonRequireMembers: '不限'
  },
  users: {
    recruit: {
      slogan: '投履歷',
      needActiveAccount: '要投遞履歷，請先透過 E-mail 認證啟用你的帳號。',
      chooseYourResume: '請選擇你要投的履歷',
      messageToCompany: '傳給公司的訊息 Cover Letter',
      checkAccount: '察看帳號狀態',
      pleaseChooseOneResume: '請先選擇你的履歷。',
      recruitFailed: '投遞履歷失敗了，請稍後再試一次。',
      pleaseFillTheMessages: '請填寫傳給公司的訊息。',
      defaultRecruitMessage: '您好，我叫 {name}，我對貴公司《{vacancy}》職缺很有興趣，在此附上履歷，希望能有機會參加面試，感謝！'
    },
    saved: {
      slogan: '管理我的 Debut',
      moveFolder: '移動資料夾',
      total: '共收藏 {count} 個工作',
      moveToFolder: '移動到資料夾',
      chooseFolders: '請選擇你要移動的資料夾',
      sort: {
        saved: '收藏的時間',
        newest: '最後更新時間'
      }
    },
    settings: {
      slogan: '個人資料管理',
      yourAccountNotActived: '你的帳號尚未啟用，請&nbsp;',
      resentActiveEmail: '按此重新寄送',
      activeAccountEmail: '&nbsp;帳號啟用認證信。',
      setPassword: '變更密碼設定',
      oldPassword: '請輸入舊有密碼',
      newPassword: '請輸入新密碼',
      repeatPassword: '請再輸入一次新密碼',
      sentActiveEmailSuccessed: '傳送成功，請留意你的 E-mail 信箱。',
      sentActiveEmailFailed: '傳送失敗了，請稍後再試一次。',
      updateAccountFailed: '更新資料錯誤了，請稍後再試一次。',
      ssoEmailIsInvalid: '你的信箱資料不正確，請修改你的 E-mail 信箱。',
      oldPasswordIsIncorrect: '你輸入的舊密碼錯誤，請再試一次。'
    },
    profile: {
      information: '基本資訊',
      avatar: '個人照片',
      avatarDescription: '個人檔案上的個人照片，支援 JPG、PNG 或 GIF 格式，建議尺寸 380x380px，檔案大小最多 5MB',
      username: '姓名',
      pleaseFillYourName: '請輸入您的姓名',
      englishName: '英文姓名',
      pleaseFillYourEnglishName: '請輸入您的英文名',
      contactInformation: '聯絡資訊',
      phoneNumber: '電話',
      pleaseFillphoneNumber: '請輸入您的聯絡電話',
      cellphoneNumber: '手機號碼',
      pleaseFillcellphoneNumber: '請輸入您的手機號碼',
      canContactPeriods: '可聯繫時間',
      address: '通訊地址',
      pleaseFillTheAddress: '請輸入您的詳細地址',
      saveUserProfileFailed: '更新個人資料失敗了，請稍後再試一次。',
      gender: '性別',
      englishNameErrorMessage: '英文姓名僅限使用英文。',
      phoneNumberTips: '電話號碼僅限數字、空格、加號、減號與 # 符號。',
      avatarCannotBeEmpty: '個人照片不可為空值。',
      usernameCannotBeEmpty: '姓名不可為空值。',
      birthdayCannotBeEmpty: '出生日期不可為空值。',
      emailCannotBeEmpty: 'E-mail 格式錯誤或不可為空值。',
      cellphoneCannotBeEmpty: '手機號碼格式錯誤或不可為空值。',
      addressCannotBeEmpty: '通訊地址不可為空值。'
    },
    create: {
      careerInformation: '求職資料',
      onBoard: '最快可上班日',
      anyTime: '隨時',
      employmentStatus: '就業狀態',
      jobTitle: '希望的職稱',
      salary: '希望的待遇',
      resumeName: '履歷名稱',
      resumeDescription: '你可以針對不同的專長，創建多份履歷，凸顯你在不同領域的能力。',
      openResume: '開啟履歷',
      closeResumeDescription: '關閉履歷: 關閉履歷後，投遞過的履歷也會變成不可閱讀',
      image: '個人圖片',
      imageDescription: '履歷上的個人照片，支援 JPG、PNG 或 GIF 格式，建議尺寸 380x380px，檔案大小最多 5MB',
      addImage: '新增圖片',
      username: '姓名',
      gender: '性別',
      englishName: '英文姓名',
      slogan: '建立履歷',
      description: '建立您的履歷，讓業主能更瞭解你。',

      experiences: '學歷經歷',
      workExperiences: '工作經歷',
      educational: '學歷',
      resumeContent: '履歷內容',
      skills: '專業技能',
      languages: '語言能力',
      licenses: '證照與成就',
      introduction: '自我介紹',
      links: '相關連結',
      attachments: '附件',
      attachmentDescription: '您可以上傳作品集、自傳或是自定格式的履歷，增加企業對您的印象。',
      chooseFiles: '選擇檔案',
      linkUrl: '輸入網址',
      modify: '編輯',
      companyName: '公司名稱',
      companyJobTitle: '職稱',
      companyLocation: '地點',
      companyPeriod: '期間',
      companyOnBoard: '在職中',
      jobDescription: '工作內容',
      addNewExpreiences: '新增工作經歷',
      modifyExperiences: '修改工作經歷',
      contactInformation: '聯絡資訊',
      phoneNumber: '電話',
      cellphoneNumber: '手機號碼',
      contactPeriod: '可聯繫時間',
      address: '通訊地址',
      schoolName: '學校名稱',
      degree: '學歷',
      departmentName: '科系名稱',
      educationPeriod: '就學期間',
      addNewEducational: '新增學歷',
      modifyEducational: '修改學歷',
      openResumeDescription: '公開履歷: 公司可見您的履歷',
      onBoardCannotBeEmpty: '請填寫最快可上班日或勾選隨時',
      jobTitleCannotBeEmpty: '請填寫希望的職稱',
      salaryCannotBeEmpty: '請填寫希望的待遇',
      introductionCannotBeEmpty: '請填寫自我介紹'
    },
    history: {
      company: '公司',
      vacancy: '職缺',
      slogan: '我的應徵記錄',
      total: '共投遞 {count} 個職缺',
      recruitedDate: '投遞日期',
      companyName: '公司名稱',
      vacancyName: '職缺名稱',
      resumeName: '履歷名稱',
      coverLetter: 'Cover Letter',
      closed: '已結束'
    },
    resumes: {
      slogan: '我的履歷',
      total: '共有 {count} 件履歷',
      name: '履歷名稱',
      lastUpdated: '最後更新',
      view: '觀看履歷',
      modify: '編輯',
      clone: '複製成新的',
      delete: '刪除',
      status: '履歷狀態',
      cloneResumeFailed: '複製履歷失敗了，請稍後再試一次。',
      removeResumes: '確定要刪除所選的履歷？',
      closeResumes: '關閉履歷',
      openResumes: '開啟履歷'
    }
  }
}

module.exports = tw



// WEBPACK FOOTER //
// ./src/locales/tw.js